export default function normalizeFilterParams(app, packageName) {
  const { haveIap, price } = app;
  const hasPurchase = haveIap || Boolean(price);
  return {
    packageName,
    has_purchase: Number(hasPurchase),
  };
}
